import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import theme from 'theme/theme';

const Textarea = styled.textarea`
  box-sizing: border-box;
  width: 100%;
  padding: 10px 20px;
  border: 1px solid ${theme.colors.mediumLight};
  border-radius: 0;
  color: ${theme.colors.black};
  background: ${theme.colors.white};
  font-size: ${theme.fontSizes.default};
  outline-offset: -3px;
  &:focus {
    outline: none;
  }
  ${(props) => props.hasError && css`
    &, &:focus {
      outline: 3px solid ${theme.colors.primary};
    }
  `}
`;
Textarea.propTypes = {
  hasError: PropTypes.bool,
};
Textarea.defaulProps = {
  hasError: false,
};

export default Textarea;
